export default __webpack_public_path__ + "static/differential-equations-58c0fb6c484605eadfad7e7b1a121bd4.svg";